import { Constants } from '@bingads-webui-theme-2018/theme-fluent';

const paddingLeft = Constants.PagePadding.smallMainSectionLeftPadding;

export const gridPaddingStyle = () => ({
  '.small-padding-left.bingadsgrid': {
    paddingLeft: 0,
    '& .table-container': {
      '& table.table': {
        '& tbody tr td:first-child': {
          paddingLeft,
        },
        '& thead.header tr th:first-child': {
          paddingLeft,
        },
        '& tfoot.footer tr td': {
          paddingLeft,
        },
        '& colgroup.column-group col.col-Status': {
          minWidth: 50,
          width: 50,
        },
      },
    },
    '& .flex-layout': {
      '& .flex-column-group': {
        '& .flex-cell[data-column=selection]': {
          paddingLeft,
        },
        '& .flex-cell[data-column=Status]': {
          minWidth: 50,
          width: 50,
        },
      },
      '& .tfoot.footer .pagination-row': {
        paddingLeft,
      },
    },
  },
});

export const pagePaddingStyle = () => ({
  '.small-padding-left .disclaimer-banner': {
    paddingLeft,
  },
  ...gridPaddingStyle(),
  '.small-padding-left .navbar .container-fluid': {
    paddingLeft,
  },
});
